import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'floating-label-react';

const FloatingTextarea = ({
  name,
  type,
  placeholder,
  onChange,
  onBlur,
  value,
  maxlength,
  required,
  touched,
  error,
}) => (
  <div className="w-full font-malee pb-2 md:pb-4">
    <div className="textarea-wrap relative">
      <FloatingLabel
        component="textarea"
        name={name}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        required={required}
        maxlength={maxlength}
        className={`${((touched && !error && value) || (!error && value)) &&
          'textarea-checked'} ${touched && error && 'textarea-error'}`}
      />
    </div>
  </div>
);

FloatingTextarea.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool,
};

export default FloatingTextarea;
